module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e4528"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c15_r1#d6e2",
      "id": "d7e2"
    }
  }, [_vm._v("Inspiring "), _c('b', [_vm._v("Originals ")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e4598"
    }
  }, [_vm._v("Dive into wonderful homes that showcase original midcentury details, architecturally appropriate renovations, and inspired furnishings. Their homeowners love vintage and contemporary modern, making for a personalized take on stylish living.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0009_001",
      "id": "d14e174",
      "src": "images/AtomicRanchBook_0009_001.jpg"
    }
  })]), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e50210"
    }
  }, [_vm._v("Eichler "), _c('b', [_vm._v("Two-Timers ")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0010_001",
      "id": "d14e179",
      "src": "images/AtomicRanchBook_0010_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e51210"
    }
  }, [_vm._v("When the homeowners arrived on moving day, the front of the house was completely exposed. After the renovation, the flat-roof Eichler looks pristine and original.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e54010"
    }
  }, [_vm._v("Monika Kafka and Tom Borsellino had already lived in this San Jose neighborhood before relocating to Chicago. But work and a hankering for the sunny, casual California lifestyle pulled them back. Borsellino found a house and bought it with his wife’s blessing but without her actually seeing it. He told her it needed a little work, and an early inspection indicated some dry rot and termite damage. Mostly it seemed to be suffering from claustrophobic ‘60s-meets-Asian decor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e57410"
    }
  }, [_vm._v("When the couple, with a two-year-old and two-month-old in tow, pulled up to move into the house, the front facade had been stripped down to the insulation, and the baby’s room was completely open to the street. It was 105 degrees outside, but an even more stunning 108 degrees inside. Kafka was not charmed. In all, 90 percent of the distinctive grooved Eichler siding needed replacing, and while the walls were open, the couple opted to insulate and ground the electrical system. Although the roof was only four years old, they decided to install operable skylights in several rooms and replace the black tar and gravel with an insulating foam roof, which Borsellino estimates has cooled off the house 15 to 20 degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e61610"
    }
  }, [_vm._v("The construction crew had found substantial damage in most of the posts and some of the beams, and awaited Borsellino’s directions on what he wanted to do—as if he had an option. The original kitchen cabinets were painted a sickly harvest gold, and Borsellino’s first inclination—though one that runs counter to his preservationist tendencies— was to rip it out. But with the huge structural job they had fallen into, the kitchen’s aesthetics were the least of their worries.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e64410"
    }
  }, [_vm._v("“From late summer on, three to five guys were here every day,” Kafka says. She ")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0011_001",
      "id": "d14e190",
      "src": "images/AtomicRanchBook_0011_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0012_001",
      "id": "d14e192",
      "src": "images/AtomicRanchBook_0012_001.jpg"
    }
  })]), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e66313"
    }
  }, [_vm._v("our previous Eichler "), _c('i', [_vm._v("was the beta plan for this later model;")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("this house is")]), _vm._v(" much more functional.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0013_001",
      "id": "d14e201",
      "src": "images/AtomicRanchBook_0013_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e68113"
    }
  }, [_vm._v("The refrigerator is one of the few new elements in the lightly renovated kitchen. With the mustard-color paint replaced with crisp black, and the fretwork room divider removed, the original white laminate counters, built-in Thermador wall oven, and mahogany wall paneling look very today.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e72913"
    }
  }, [_vm._v("became adept at feeding the crew and facilitating any construction snags while juggling the kids’ needs. “But by April it was my house again,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e74513"
    }
  }, [_vm._v("Instead of slate, bamboo, or hardwood flooring, the couple settled on vinyl composite tile from Armstrong as a good, affordable option—$4,000 versus $24,000 for slate—and the closest to the tract’s original 9-inch asbestos floor tiles. Some of the original mahogany paneling had faded or was beyond repair; Borsellino used a combination of Watco Golden Oak and Fruitwood with some orange universal colorant mixed in to match new pieces to the existing. In the kitchen, they simply painted the cabinets black and found they liked the kitchen just fine that way. The baths were a different matter, though.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e79613"
    }
  }, [_vm._v("“Joseph Eichler didn’t think out the baths in these houses,” Borsellino says, “so I have no problem making changes. They ran the same mahogany paneling from the bedroom into the bath and tiled ")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0014_001",
      "id": "d14e210",
      "src": "images/AtomicRanchBook_0014_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0015_001",
      "id": "d14e211",
      "src": "images/AtomicRanchBook_0015_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e82915"
    }
  }, [_vm._v("Facing: The family room and kitchen share one expansive space. The couch and light fixture are new, while the dining table, chairs, and bar cart are vintage.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e85515"
    }
  }, [_vm._v("Above: In this Eichler model, the living room is separate from the kitchen and family room, but still has plenty of light and architectural detailing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e88115"
    }
  }, [_vm._v("right on top of it. Of course they’re all full of dry rot and termite damage by now.” Taking a clue from the one-inch tile on the shower floor, they installed glass mosaic tile throughout the toilet and shower area and added a skylight to brighten up the small room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e89915"
    }
  }, [_vm._v("The couple furnished with a mix of vintage, modern reissues, and inexpensive kid-proof furniture from IKEA. “The ‘dog-bone’ sofa is from Modernica and the Saarinen table with the lazy Susan in the center was bought on eBay,” Kafka says. And while the lamp over the table and the dark couch in the living room are IKEA designs, and two armchairs were retrieved from someone’s curb, the living room arc lamp is from Design Within Reach and a George Nelson bench used for a coffee table was bought through Herman Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e94915"
    }
  }, [_vm._v("Despite a rather rocky start with their dream house, they don’t regret the move one bit. Borsellino even sees how Eichler and his architects continued to learn what worked and what didn’t as they built their numerous tracts. “Our previous Eichler was the beta plan for this later model; this house is much more functional,” he says. “They had 15,000 tries to get it right and they did.”")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e99016"
    }
  }, [_vm._v("Desert "), _c('b', [_vm._v("Alexander ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e99716"
    }
  }, [_vm._v("A late-’40s dinette set makes the Herman Miller chairs and couch look coolly elegant. The color in the home comes from furniture and collectibles like the coral-colored “Jitterbug” wall sculpture by Frederick Weinberg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e103416"
    }
  }, [_vm._v("When Nick Lorenzen was visiting a friend in Palm Springs, he fell in love with a neighborhood of homes built in the late ’50s by the Alexander Construction Company. He ended up buying a 1,200-square-foot home a couple of blocks away with the same floor plan as his friend’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e105416"
    }
  }, [_vm._v("The investment was a bit of a gamble, as the neighborhood was run down and most homes were for sale or had bars on their windows. But he was among the pioneers who saw the midcentury tract’s potential, and three years later the area has undergone a renaissance. “Since I’ve lived here, my block has completely turned around; it’s beautiful now,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e107816"
    }
  }, [_vm._v("Structurally, the tract house was in good condition, and by refreshing the finishes and cleaning up the yard and pool, Lorenzen made the home look new again. He did much of the work himself—painting, a new fence, landscaping, removing layers of carpet and linoleum from the concrete slab before putting on a new top coat—and had pros do the big jobs: driveway replacement and a new foam roof. “I did everything on a hairdresser’s budget, one project at a time over five years,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e110716"
    }
  }, [_vm._v("The three-bedroom, two-bath house has a typical open floor plan with the kitchen, dining, and living room sharing one space. A wall of windows opens up to a shaded patio and pool via sliding glass doors. “People are always shocked that it feels so big,” he notes. “I count the covered patio seating area as part of my home, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0017_001",
      "id": "d14e237",
      "src": "images/AtomicRanchBook_0017_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e113618"
    }
  }, [_vm._v("Lorenzen’s rooms are furnished with vintage and reproduction pieces. A George Nelson couch and chair came from the home of a Herman Miller employee, and many of his tables, lamps, and decorative elements were picked up at Palm Springs–area thrift stores. His design sensibilities are secure enough to stir in a 1947 green-and-black vinyl dinette set that’s a family heirloom— a piece seemingly at odds with the later modern classics. Somehow it all works against his neutral palette of white walls and scored concrete floors lit by the brilliant desert sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0018_001",
      "id": "d14e241",
      "src": "images/AtomicRanchBook_0018_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e119419"
    }
  }, [_vm._v("Facing: The guest bedroom has a bit more kitsch thrown into the mix: a Harry Bertoia–designed chair sits next to a generic Danish modern bed with an Alexander Calder–motif bedspread. The Carlo of Hollywood artwork in the asymmetrical frames is either good “bad” art or high camp—depending on your point of view.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e124419"
    }
  }, [_vm._v("Below: Alexander Construction, a firm that specialized in affordable second homes and doubled the size of Palm Springs in the ’50s and ’60s, built this 1958 ranch house. Architect William Krisel varied the roof lines, front facades, and siting of the Palm Springs tract homes, but the floor plans are basically the same.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0019_001",
      "id": "d14e246",
      "src": "images/AtomicRanchBook_0019_001.jpg"
    }
  })]), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e131320"
    }
  }, [_vm._v("Way-Back "), _c('b', [_vm._v("Machine ")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0020_001",
      "id": "d14e251",
      "src": "images/AtomicRanchBook_0020_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e132220"
    }
  }, [_vm._v("Above: This ranch has a typical plain-Jane look: a stucco and flagstone facade with small aluminum windows, an attached garage, and an aggregate path leading to a mahogany double front door.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e135320"
    }
  }, [_vm._v("Facing: Eclectic probably best describes the family room furnishings: a Heywood-Wakefield dining table and dog-bone chairs, vintage bar stools that are suspended from the breakfast counter, and coffee table and green sectional that came with the house. Yes, the rotary wall phone in the kitchen still works, as do the original appliances. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e140620"
    }
  }, [_vm._v("An almost totally original ranch house built in 1966 came to the second owners with its popcorn ceilings, vintage kitchen appliances, tuck-and-roll wet bar, built-in barbecues, and monolithic S-shaped living room rock wall intact. There was original terrazzo in the entry, pristine paneling, and a bathroom with fleurs-de-lis on the shower enclosure doors.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e143420"
    }
  }, [_vm._v("The floor plan is a bit more traditional than post-and-beam midcentury homes: a rather dark front entry opens up to a living room with floor-to-ceiling glass overlooking a patio with views of the surrounding hillsides and downtown Los Angeles. Low-ceilinged hallways lead to bedrooms and baths on the right, while another narrow hall takes you to the combined family room/kitchen on the left. This space is the heart of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e146220"
    }
  }, [_vm._v("“The family room had one of the coolest wet bars we’d ever seen,” owner Apryl Lundsten says about their first looky-loo tour of the home. “It’s upholstered in black-and-silver vinyl and has four mint-condition barstools. Next to it is an indoor barbecue with a rotisserie and all of the original tools, and above it on the rock wall is a built-in clock that still works. The place was obviously a party pad.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e149120"
    }
  }, [_vm._v("The adjoining kitchen, with its vintage stainless-steel built-in appliances—cooktop, wall oven, refrigerator, toaster, coffeemaker, and aluminum foil dispenser—is separated from the family room by a low breakfast bar with suspended gold chairs that would be at home in a ’60s Vegas coffee shop. Outside on the flagstone patio that comprises the backyard on this steep hillside lot is another barbecue built into a massive circular dining table.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0021_001",
      "id": "d14e265",
      "src": "images/AtomicRanchBook_0021_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e153122"
    }
  }, [_vm._v("Apryl and husband David Spancer have left the house alone while getting to know it, and other than an engineered wood floor in the family room, the home looks much as it did when it was built. They found their eclectic collection of vintage and retro-influenced furniture fit right in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e156022"
    }
  }, [_vm._v("The couple christened the house with a party that included Marisa McBride, one of three daughters of the original owners. She shared old photos and anecdotes about growing up in the house, and when she saw the orange beautician’s sink in the laundry room off the kitchen, she got teary-eyed. “I have the hairdresser’s chair that matches the sink,” she said. “I’d love for you guys to have it. Mom would want it to be here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0022_001",
      "id": "d14e270",
      "src": "images/AtomicRanchBook_0022_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e160423"
    }
  }, [_vm._v("Facing: The living room of this traditional ranch has an S-shaped flagstone wall, a cantilevered slate hearth, and ubiquitous popcorn ceilings. Underneath the up-lit soffits, full-length drapes open to views of the Los Angeles basin. \n")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e164523"
    }
  }, [_vm._v("Below: The lounge-lizard bar was what really grabbed the new owners when they first toured the house: what could be cooler than glittery vinyl barstools and tuck-and-roll upholstery?")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0023_001",
      "id": "d14e275",
      "src": "images/AtomicRanchBook_0023_001.jpg"
    }
  })]), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e168224"
    }
  }, [_vm._v("Houston "), _c('b', [_vm._v("Nights ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e168924"
    }
  }, [_vm._v("A small Pfister settee from Knoll, glass-topped coffee table from Scope Furniture, and B&B Italia wall storage unit furnish this Houston living room. The shoji screen was moved to the window wall, but originally closed the living room off from the dining room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e173024"
    }
  }, [_vm._v("Houston’s postwar houses are typically brick affairs, with styles ranging from neo-Colonial white-pillar ranches to flat-roof Modernist designs. In the Memorial Bend neighborhood, Cathie and Rick Johnson have been in their 1958 house for more than twenty years. Only the third owners, the couple inherited a largely original but neglected house with brown shag carpeting and a ferocious insect infestation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e175624"
    }
  }, [_vm._v("The long, low house is almost hidden by the mature trees on the large 90-foot by 110-foot lot, and the street facade is private to the point that it might be mistaken for a library or a walled compound. Originally, the sole front windows were narrow clerestories sandwiched between the top of the brick walls and the two-foot roof overhang. A porte cochere—a drive-through, roofed shelter at the front entrance and a popular feature in Houston—hides cars from view and stands in for a garage or a carport.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e178424"
    }
  }, [_vm._v("The 2,300-square-foot house came to the Johnsons with an incongruous bay window on the front and a tacked-on metal structure known as a “Western Room” that took up a big chunk of the backyard and blocked light from the family room. The couple tore off the shed immediately but debated about bricking up the unoriginal bay window to restore the front facade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e180724"
    }
  }, [_vm._v("“Because it let some needed sunlight into the kitchen’s breakfast area and the view was nice, we decided to keep the window,” Cathie, an interior designer, says. The couple lived with the bay window for years, but eventually found a more midcentury-appropriate version, an aluminum-framed casement model from RAM Industries.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0025_001",
      "id": "d14e291",
      "src": "images/AtomicRanchBook_0025_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e184026"
    }
  }, [_vm._v("There was an almost-new Wood-Mode kitchen in place when the Johnsons bought in 1983, so they kept that but recently lowered the height of the bar between the family room and kitchen and put in new limestone counters. Other than the original cooktop, appliances have been replaced, and a modern ventilating fan and improved lighting installed. The glass table and see-through wire Bertoia chairs in the small breakfast area help keep it from seeming claustrophobic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e188026"
    }
  }, [_vm._v("The Johnsons have some midcentury furniture—the Bertoia chairs and a rosewood Eames lounge chair and ottoman they bought in 1981—but prefer a contemporary sensibility. Cathie upholstered the entry hall walls in a tan silk, installed a wall of smoky glass in the guest bath to go with its original black terrazzo, and annexed closet space to expand the master bath to include a Jacuzzi tub.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e191826"
    }
  }, [_vm._v("She also designed a horizontal-slat wood fence along the side of the property that mimics the bands of brick across the front facade. It helps disguise the presence of a highway that cut through Memorial Bend about ten years ago. In the backyard, another decorative grid fence backed by window screening camouflages a storage shed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e194226"
    }
  }, [_vm._v("Like the Johnsons, the house and the neighborhood have evolved in the past twenty years. “People don’t always realize how comfortable modern architecture is,” Cathie says. “We bought a home with good bones; it just needed a little TLC.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0026_001",
      "id": "d14e300",
      "src": "images/AtomicRanchBook_0026_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0027_001",
      "id": "d14e301",
      "src": "images/AtomicRanchBook_0027_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e197127"
    }
  }, [_vm._v("Left: The sturdy rustic chopping block gives the kitchen a shot of personality. The glass hood of the exhaust fan helps keep the breakfast nook part of the kitchen and blocks a minimum of light from the new aluminum windows.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e200727"
    }
  }, [_vm._v("Above: The entry to this Houston home, set back between the lanterns, is hidden from the street. The semicircular driveway passes through a porte cochere, which stands in for a garage or carport.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e204128"
    }
  }, [_vm._v("Appreciating "), _c('b', [_vm._v("the Intent ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e204828"
    }
  }, [_vm._v("A 1955 custom home with Googie-esque lines has quite an impact as you approach up a steep private drive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e207128"
    }
  }, [_vm._v("Only the second owner of a 1955 home designed by Southern California architect Clair Earl, Chris Burusco realized he’d stumbled across a gem when his realtor drove him up the steep private driveway to the home. “I knew I wanted a ’50s modern house—one with a flat roof, glass walls, a carport in front,” he says, “and it took about six months of looking to find one. Most were 1970s stucco boxes or ’50s ranch houses without all the bells and whistles I wanted. This one was a diamond in the rough.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e210628"
    }
  }, [_vm._v("He gently took the house back to what it was meant to be, which pleased the 93-year-old seller no end. Jean Russom and her late husband, Alan Dailey, built the home, which had a Palos Verdes stone fireplace and chimney, polished concrete floors throughout, radiant heating in the living room and patio floors, vibrant colors for each of the sliding doors in the kitchen and carport cabinets, and a built-in stereo speaker in the hallway to the bedrooms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e214128"
    }
  }, [_vm._v("Alan died only months after the couple moved in, and during the years that followed, an interior decorator friend of Russom’s took over and made sweeping changes that included draperies on the floor-to-ceiling windows, wallpaper, and other modifications not in keeping with the original intent. “The decorator did everything opposite to what was done in the first place and I was in no emotional condition to argue,” she says. “My talents lay in other directions, I guess, and it got into a mess. I’m so glad that it’s put back to where it should be now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0029_001",
      "id": "d14e319",
      "src": "images/AtomicRanchBook_0029_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0030_001",
      "id": "d14e320",
      "src": "images/AtomicRanchBook_0030_001.jpg"
    }
  })]), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e218831"
    }
  }, [_c('i', [_vm._v("the house is so ")]), _vm._v("different from anything"), _c('br'), _vm._v(" "), _c('i', [_vm._v("I ever thought")]), _vm._v(" of doing, "), _c('i', [_vm._v("but")]), _vm._v(" its wonderful."), _c('i', [_vm._v(" I just can’t")]), _vm._v(" imagine doing it any better.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0031_001",
      "id": "d14e336",
      "src": "images/AtomicRanchBook_0031_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e221431"
    }
  }, [_vm._v("Facing: The living room is all angles and interesting surfaces: the cork floor isn’t original but is typical of the period, and the ceiling and far wall are tongue-and-groove solid wood. The entire room is lit by a wall of floor-to-ceiling windows and sliding glass doors, which lead out to the covered patio and view of the foothills.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e226631"
    }
  }, [_vm._v("Above: This small area in the kitchen stands in for a dining room in the custom-designed house. With a large window looking out toward the front driveway on the south, a sliding glass door leading to a small patio to the west, and a pass-through to the living room on the north wall, the diminutive space doesn’t feel tight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e231631"
    }
  }, [_vm._v("The 1,950-square-foot house has three bedrooms and two baths. An angular living room with a pass-through bar to the compact kitchen and dining area is the most dynamic space, with its channeled wood ceiling and prow-like white wall and soffit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e233531"
    }
  }, [_vm._v("Burusco had wall-to-wall carpet taken up, the concrete slab sealed, and cork squares put down that look as if they are original. The project was fiscally daunting, though. “The first bid was for $24,000 from a local flooring company,” he remembers. “But a tile guy who had worked on a local showcase house said he’d do it for about a third of that.” Except for the original slate floor in the entryway and the tiled baths, there is now cork throughout the house.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e236131"
    }
  }, [_vm._v("Coming from a condo with roommates, Burusco didn’t have much in the way of midcentury furnishings. He did own a tan leather Eames lounge chair and ottoman, a couple of Danish modern pieces, and four Eames DAR shell chairs with original bases. Joining them are a new Warren Platner–designed coffee table in the living room and an affordable Modernica Case Study series couch, both lit by a “Polluce” floor lamp from Artemide. A vintage Jens Risom armchair with orange cushions is a particular favorite, as is his Saarinen dining table, which bears the dings of a previous owner’s daily use.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e242131"
    }
  }, [_vm._v("“The house is so different from anything I ever thought of doing, but it’s wonderful. I just can’t imagine doing it any better,” Russom says. “The fact that Chris loves the house—that’s the most important thing of all.”")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e244532"
    }
  }, [_vm._v("As Original "), _c('b', [_vm._v("as it Gets ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e245232"
    }
  }, [_vm._v("The gable-roof atrium models are some of the most arresting Eichler designs. The area to the right of the front door functions as a carport, plus there is an attached two-car garage. Behind the orange door is the private atrium, which adds additional living space to the floor plan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e250032"
    }
  }, [_vm._v("As much as they love the architecture of their A. Quincy Jones–designed Eichler, Clay and Cindy Morrow are really there for the neighborhood. With the advent of their first child, the couple decided they needed to move somewhere safer with better parking, more level streets, good schools, a larger single-level house—in short, a family neighborhood. When plans to build a prefab house fizzled, their friends were aghast to learn they were considering moving an hour away to outer suburbia. And move they did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e253132"
    }
  }, [_vm._v("There are about 125 homes built by Joseph Eichler in Thousand Oaks, California. The Morrows’ five-bedroom house dates from 1964, and they bought it from the original owner. Other than needing cleaning and painting, the house was relatively unscathed. “We knew that it was potentially great because it had almost no ’70s remodeling done to it. That was a huge plus,” Cindy says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e256132"
    }
  }, [_vm._v("The Morrows note the Japanese architectural influences seen in their home, particularly the aggregate entry floor in the living room. “It’s normally the first thing to go when people remodel these homes,” Cindy comments. “My grandfather’s house in Japan had an aggregate floor where you’d take off your shoes before entering the home. It’s a subtle transition to the inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e258332"
    }
  }, [_vm._v("Their biggest project turned out to be removing the damaged original tile under the wall-to-wall carpeting. Neither wood nor carpet over the radiant heating made sense to them, and the slab had cracks and stains once Cindy finished removing the tile adhesive with solvent. (The couple vetoed the idea of sanding off the adhesive due to concerns about airborne asbestos.) They decided to have a new self-leveling 1/8-inch-thick cement coating poured over the existing slab, which ran about half the price of wood flooring.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0033_001",
      "id": "d14e365",
      "src": "images/AtomicRanchBook_0033_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e262134"
    }
  }, [_vm._v("Below: The living room has floor-to-ceiling views of the backyard on both sides of the brick fireplace. The Danish modern chairs and side table are paired with a new couch and a vintage Oriental rug.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e265234"
    }
  }, [_vm._v("Facing: This Eichler’s kitchen is just about original, including the low cooking peninsula and swing-out table that offers convenient seating for the family’s children.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0034_001",
      "id": "d14e370",
      "src": "images/AtomicRanchBook_0034_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0035_001",
      "id": "d14e371",
      "src": "images/AtomicRanchBook_0035_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e269135"
    }
  }, [_vm._v("“The floor was kind of a disaster,” Clay concedes. “We had to stain it darker than we wanted, the texture is different from room to room because the people who did it didn’t have experience with this particular product, and it shows every pet hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e270735"
    }
  }, [_vm._v("Almost all their furnishings were purchased inexpensively from thrift stores or eBay, or are hand-me-downs. A couch in the family room and the Persian rug in the living room are the only things they purchased for this home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e272535"
    }
  }, [_vm._v("“We’re not fans of houses that don’t look lived in,” Cindy says, “with all that perfect, expensive furniture. Clay and I both feel that there’s too much good design to only have things that are from 1964.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e273735"
    }
  }, [_vm._v("“Just going to a store and buying a living room or bedroom of reissued furniture doesn’t have the right feeling,” Clay adds. “That seems forced and impersonal.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e275335"
    }
  }, [_vm._v("“I like the fact that we don’t have everything by a designer, either vintage or reissued, and I like that our furniture is a mix of different eras,” Cindy continues. “We might have a modern couch, but it’s sitting next to a Scandinavian side chair or a table from 1940 with an inlaid tile top. If we like something, we get it; it doesn’t matter who made it or where it came from.”")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e277835"
    }
  }, [_c('b', [_vm._v("EICHLER’S REACH ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e278535"
    }
  }, [_vm._v("Joseph Eichler became a builder in the late ’40s,when housing for some 10 million veterans, many of whom were starting families, was a major driving force in the economy. The homes’ post-and-beam construction allowed for open floor plans and walls of glass facing private backyards, and incorporated such innovations as radiant floor heating. Eichler’s willingness to hire talented architects and his devotion to quality craftsmanship and modern living resulted in houses that looked custom but were within reach of first-time home buyers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e282935"
    }
  }, [_vm._v("Almost all Eichlers are in California—350 homes in Orange, 200-plus more in Thousand Oaks and Granada Hills, 60 or so in Sacramento, and in the San Francisco Bay Area, several thousand more, including two tracts that are now on the National Register of Historic Places. Four years ago, the Society of Architectural Historians held a hugely popular tour of Orange County Eichlers, and today the homes are greatly prized.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e287136"
    }
  }, [_vm._v("Colorado "), _c('b', [_vm._v("Modernism ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e287836"
    }
  }, [_vm._v("A Bertoia Bird chair and ottoman pick up the colors in the artwork over the fireplace in this Colorado home. A $20 Eames plywood dish table with “issues,” according to the owners, holds a Bennington elephant and a lion by Lisa Larson for Gustavsberg. The pole lamp is by Lightolier, and two George Nelson vintage clocks hang on the wall next to an Eames leg splint.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e294836"
    }
  }, [_vm._v("Frank Sarcia and Jim Eveleth have been collecting modern furniture for fifteen years. When they found a ’50s house in Arapaho Hills in the Denver suburb of Littleton, it all gelled: this was the home they and their furniture were meant to have.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e297136"
    }
  }, [_vm._v("“The house wasn’t run down really,” Sarcia says, “but it needed paint badly and the wood was in poor condition in some places. The previous owners were in their eighties and thank God nothing had been changed. It still had the original range and oven, vintage bathroom cabinets, and original wall sconces. That’s really what I was looking for in a house.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e299236"
    }
  }, [_vm._v("The pair kept their midcentury galley kitchen with its original sliding-door cabinets, and painted the architectural elements in Mondrian-esque hues—bright orange, green, and white. The pony wall separating their living room from the kitchen was painted yellow, in marked contrast with the new slate floors, gray cement block fireplace wall, and dark tongue-and-groove wood ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e302036"
    }
  }, [_vm._v("Their living room is a veritable midcentury museum. A vintage Eames sofa and surfboard table, reissued Harry Bertoia Bird chair and ottoman, and a George Nelson Coconut chair with original fabric are iconic pieces. One of their favorite sources is Mod Livin’ in Denver, but they’re also inveterate yard-salers. Even their den and kitchen are packed with modern stuff: Catherine Holmes bowls atop the kitchen cabinets, and an ")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0037_001",
      "id": "d14e404",
      "src": "images/AtomicRanchBook_0037_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0038_001",
      "id": "d14e405",
      "src": "images/AtomicRanchBook_0038_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e306738"
    }
  }, [_vm._v("Above: Arapaho Hills near Denver is the location of this ’50s tract home.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e308338"
    }
  }, [_vm._v("Right: The mosaic ceramic tile in this original bath is back in style, while the angle-front vanity packs as much storage as possible into the compact space.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e310638"
    }
  }, [_vm._v("Facing: Saarinen dining chairs from Mod Livin’ in Denver surround a matching table in the kitchen’s dining nook; over them hangs a Nelson saucer lamp. In the adjoining living room, a Nelson Coconut chair dates from 1957.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e314138"
    }
  }, [_vm._v("early Womb chair and Evans-label Eames plywood chair flank the TV.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e315738"
    }
  }, [_vm._v("The home was built by Clyde Mannon, who worked on nearby Arapahoe Acres as well. Sarcia and Eveleth’s house has transom windows among the fixed clerestories, and the decorative block detailing seen on the fireplace wall is repeated on the front facade and on the garage wall. A quirk of the house is the two entry doors: the left one leads to the front hall and living room, while the right-hand one provides access to the furnace.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0038_002",
      "id": "d14e417",
      "src": "images/AtomicRanchBook_0038_002.jpg"
    }
  })]), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e321039"
    }
  }, [_c('i', [_vm._v("the living room is")]), _vm._v(" a veritable midcentury museum"), _c('br'), _vm._v(" "), _c('i', [_vm._v("a")]), _vm._v(" vintage Eames sofa, "), _c('i', [_vm._v("reissued")]), _vm._v(" Harry Bertoia Bird chair "), _c('i', [_vm._v("and ottoman")]), _vm._v(", ")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e323939"
    }
  }, [_c('i', [_vm._v("and a")]), _vm._v(" George Nelson Coconut chair "), _c('i', [_vm._v("with original fabric.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0039_001",
      "id": "d14e439",
      "src": "images/AtomicRanchBook_0039_001.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ead0554","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grin_ISBN9781423600022_epub_c17_r1.vue
// module id = 78
// module chunks = 0